import {IUserListFields} from "./interfaces/Interfaces";

export const USER = {
   SOURCE: 'users',
   STYLIST_SOURCE: 'stylists',
   USER_CONTACT: 'contact',
   user_id: 'id',
   country_id: 'country_id',
   username: 'username',
   email: 'email',
   gender: 'gender',
   password: 'password',
   fullname: 'fullname',
   age: 'age',
   phone_number: 'phone_number',
   address: 'address',
   latitude: 'latitude',
   longitude: 'longitude',
   introduction: 'introduction',
   profile_photo: 'profile_photo',
   background_photo: 'background_photo',
   created_at_from: 'created_at_from',
   created_at_to: 'created_at_to',
   last_activity_date_from: 'last_activity_date_from',
   last_activity_date_to: 'last_activity_date_to',
   mirron_review: 'mirron_review',
   created_at: 'created_at',
   whats_app: 'whats_app',
   user_type: 'user_type',
   usage_states: 'status',
   service_info: 'service_info',
   provider: 'provider',
   provider_id: 'provider_id',
   likes: 'likes',
   followers_count: 'followers_count',
   recent_like_count: 'recent_like_count',
   total_like_count: 'total_like_count',
   posts_count: 'posts_count',
   salon_id: 'salon_id',
   birthdate: 'birthdate',
   stylist_post_images_count: 'stylist_post_images_count',
   is_in_campaign:'is_in_campaign',
   is_salon_owner:'is_salon_owner',
   is_home_service:'is_home_service',
   verified:'verified',
   stylist_services: 'stylist_services',
   mirron_rating: 'mirron_rating',
   mirron_comment: 'mirron_comment',
   mirron_review_date: 'mirron_review_date',
   
};

export const USER_STYLIST = {
   SOURCE: 'stylists'
};

export const HAIR_PRODUCT = {
   SOURCE: 'hairProducts',
   id: 'id',
   brand_name: 'brand_name',
   style_name: 'style_name',
   color: 'color',
   position: 'position',
   style_post_id: 'style_post_id',
   created_at: 'created_at',
   updated_at: 'updated_at'
};
//
// export const STYLE_POST_IMAGES ={
//    SOURCE: 'image_posts',
//    images: 'images',
// }

export const STYLE_POST = {
   SOURCE: 'posts',
   id: 'id',
   related_user_id: 'related_user_id',
   stylist_id: 'stylist_id',
   created_at: 'created_at',
   updated_at: 'updated_at',
   images: 'images',
   post_like: 'post_like',
   description: 'description',
   reports: 'reports',
   state: 'state',
   comment: 'comment',
   products: 'products',
   views: 'views',
   tags: 'tags',
   likes: 'likes',
   end_date: 'end_date',
};
export const SNAPSHOT = {
   SOURCE: 'snapshots',
   id: 'id',
   created_at: 'created_at',
   updated_at: 'updated_at',
   images: 'images',
   post_like: 'post_like',
   description: 'description',
   products: 'products',
   views: 'views',
   likes: 'likes',
   tags: 'tags',
   title:'title',
};


export  const SNAPSHOT_HASHTAGS={
   SOURCE: 'snapshots_hashtags',
   ids:'ids',
   id: 'id',
   name: 'name',
   created_at: 'created_at',
   number_usage: 'number_usage',
   updated_at: 'updated_at'
};


export const POST_LIKE = {
   id: 'id',
   user_id: 'user_id',
   style_post_id: 'style_post_id',
   created_at: 'created_at',
   updated_at: 'updated_at'
};

export const STYLIST_INFO = {
   SOURCE: 'stylists_info',
   id: 'id',
   user_id: 'user_id',
   salon_id: 'salon_id'
};
export const COUNTRY={
   SOURCE: 'countries',
   id: 'id',
   name: 'name',
   ids: 'data'
};
export const CITY={
   SOURCE: 'cities',
   id: 'id',
   name: 'name',
   ids: 'data'
};
export const AREA={
   SOURCE: 'areas',
   id: 'id',
   name: 'name',
   ids: 'data'
};

export const SALON = {
   SOURCE: 'salons',
   id: 'id',
   name: 'name',
   address: 'address',
   latitude: 'latitude',
   longitude: 'longitude',
   work_time: 'work_time',
   menu: 'menu',
   service: 'service',
   images: 'images',
   hair_services: 'hair_services',
   services_ids: 'services_ids'
};

export const HASH_TAG = {
   SOURCE: 'hashTags',
   id: 'id',
   name: 'name',
   created_at: 'created_at',
   number_usage: 'number_usage',
   updated_at: 'updated_at'
};
export const CAMPAIGN = {
   SOURCE: 'campaigns',
   id: 'id',
   title: 'title',
   url: 'url',
   app_banner: 'app_banner',
   website_banner: 'website_banner',
   user_segmentation: 'user_segmentation',
   country_segmentation: 'country_segmentation',
   is_enabled: 'is_enabled',
   created_at: 'created_at',
   updated_at: 'updated_at',
   country_segmentation_active: 'country_segmentation_active'
};

export const VERSION = {
   SOURCE: 'version-app',
   id: 'id',
   version: 'version',
};

export const COLUMN = {
   SOURCE: 'columns',
   id: 'id',
   title: 'title',
   categories: 'categories',
   article: 'article',
   created_at: 'created_at',
   images: 'images',
   thumbnail_image: 'thumbnail_image',
   author_photo: 'author_photo',
   author_name:'author_name',
   author_description:'author_description',
   category_id: 'category_id',
   section: 'section',
   state: 'state',
   is_highlight: 'is_highlight',
   image_alt_text: 'image_alt_text',
   meta_keywords: 'meta_keywords',
   meta_description: 'meta_description'
};

export const INQUIRY = {
   SOURCE: 'contact',
   id: 'id',
   title: 'title',
   message: 'message'
};

export const COLUMN_CATEGORY = {
   SOURCE: 'categories',
   source_name: 'category',
   id: 'id',
   //    category_id: 'category_id',
   name: 'name',
   image: 'image',
   related_at: 'related_at'
};
export const BONUS_TASK = {
   SOURCE: 'bonusTasks',
   source_name: 'bonusTask',
   id: 'id',
   name: 'name',
   description: 'description',
   score: 'score',
   is_active: 'is_active',
   order_position: 'order_position',
   reuse_delay: 'reuse_delay',
   deeplink: 'deeplink'
};

export const BONUS_COUPON = {
   order_position: 'order_position',
   SOURCE: 'bonusCoupons',
   source_name: 'bonusCoupon',
   id: 'id',
   name: 'name',
   description: 'description',
   points_cost: 'points_cost',
   is_active: 'is_active',
   reuse_delay: 'reuse_delay',
   is_future_coupon: 'is_future_coupon',
};

export const COLUMN_HAIR_SERVICE = {
   SOURCE: 'hair_services',
   source_name: 'hair_service',
   id: 'id',
   name: 'name',
   slug: 'slug',
   service_category_id: 'service_category_id'
};

export const HASHTAG_CATEGORY = {
   SOURCE: 'hashTagCategories',
   id: 'id',
   name: 'name',
   created_at: 'created_at',
   updated_at: 'updated_at'
};

export const STYLE_COMMENT = {
   SOURCE: 'styleComments',
   id: 'id',
   comment: 'comment',
   user_id: 'user_id',
   style_post_id: 'style_post_id',
   created_at: 'created_at',
   updated_at: 'updated_at'
};

export const STYLE_REPORT = {
   SOURCE: 'reports',
   reason: 'reason',
   times: 'times'
};
export const REPORT_TYPES = {
   SOURCE: 'reportsTypes',
   id: 'id',
   type: 'type'
};

export const STYLE_REVIEW = {
   SOURCE: 'reviews',
   id: 'id',
   user_id: 'user_id',
   stylist_id: 'stylist_id',
   profile_photo: 'profile_photo',
   fullname: 'fullname',
   created_at: 'created_at',
   updated_at: 'updated_at',
   comment: 'text',
   rate: 'rate'
};
export const HASHTAGS_LIST = {
   SOURCE: 'hashTagsList',
   name: 'name',
   related_at: 'related_at'
};

export const HASHTAG_MULTIPLE_LIST = {
   SOURCE: 'hashTagsListMultiple',
   id: 'id',
   name: 'name',
   type: 'type',
   related_at: 'related_at',
   ids: 'ids'
};

export const HASHTAG_RECOMMEND_LIST = {
   SOURCE: 'hashTagsListrRecommend',
   id: 'id',
   name: 'name',
   type: 'type',
   related_at: 'related_at',
   ids: 'ids'
};

export const HASHTAG_CATEGORY_LIST = {
   SOURCE: 'hashTagsListCategory',
   id: 'id',
   type: 'type',
   name: 'name',
   image: 'image',
   category_id: 'category_id',
   ids: 'ids',
   related_at: 'related_at'
};

export const HASHTAGS_LIST_TYPES = {
   SOURCE: 'hashTagsListTypes',
   id: 'id',
   name: 'name',
   type: 'type'
};

export const WORKING_WEEK: string[] = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const ARTICLE_STATES: any[] = [
   {id: 'draft', name: 'draft'},
   {id: 'publish', name: 'under publishing'}
];

export const ARTICLE_SECTION = {
   HIGHTLIGHT: 'highlight',
   CAROUSEL: 'carousel'
};

export const USAGE_STATES: Object[] = [
   {id: 'active', name: 'Active'},
   {id: 'inactive', name: 'Inactive'},
   {id: 'suspended', name: 'Suspended'},
   {id: 'resigned', name: 'Resigned'}
];

export const SERVICES_STATES: Object[] = [
   {id: 'no_salon', name: 'No salon'},
   {id: 'no_services', name: 'No salon and no home service'}
];

export const USER_SEGMENTATION: Object[] = [
   {id: 'All', name: 'All'},
   {id: 'Stylists', name: 'Stylists'},
   {id: 'Users', name: 'Users'}
];


export const PERMISSIONS = {
   ADMIN: 'admin',
   CONTENT_MANAGER: 'content-manager',
   CUSTOMER_SUPPORT_MANAGER: 'customer-support-manager'
};

export const EMPTY_WEEK: any[] = [
   {day: 1, enabled: false},
   {day: 2, enabled: false},
   {day: 3, enabled: false},
   {day: 4, enabled: false},
   {day: 5, enabled: false},
   {day: 6, enabled: false},
   {day: 7, enabled: false}
];

export const USER_TYPES: object[] = [
   {id: 'user', name: 'User'},
   {id: 'admin', name: 'Admin'},
   {id: 'stylist', name: 'Stylist'},
   {id: 'customer-support-manager', name: 'Customer Support Manager'}

];

export const KEYWORDS = {
   SOURCE: 'keywords',
   id: 'id',
   name: 'name'
};

export const REPORTS = {
   SOURCE: 'report',
   id: 'id',
   user_id: 'user_id',
   style_post_id: 'style_post_id',
   review_reported_id: 'review_reported_id',
   link: 'link',
   user_reported_id: 'user_reported_id',
   report: 'report',
   created_at: 'created_at',
};

export const FIXED_COLUMN_CATEGORY = 'Hair';

export const NOTIFICATIONS = {
   SOURCE: 'notifications',
   type: 'type',
   id: 'id',
   message: 'message',
   created_at: 'created_at',
   title: 'title',
   users_count: 'users_count',
   users_read_count: 'users_read_count',
};

export const SERVICES_CATEGORIES = {
   SOURCE: 'services_categories',
   id: 'id',
   slug: 'slug',
   name: 'name',
   order_position: 'order_position',
};
export const SERVICES = {
   SOURCE: 'services',
   id: 'id',
   slug: 'slug',
   name: 'name',
   service_category_id: 'service_category_id',
};
export const SMS_PROVIDERS = {
   SOURCE: 'sms_providers',
   id: 'id',
   name: 'name',
   sender_id: 'sender_id',
   flow_id: 'flow_id',
   is_default: 'is_default'
};

export const COUNTRIES = {
   SOURCE: 'countries',
   slack_notification_channel: 'slack_notification_channel',
   sms_provider_id: 'sms_provider_id',
   id: 'id',
   name: 'name',
   flag: 'flag',
   currency_id: 'currency_id',
   visibility: 'visibility',
   min_phone_lenght: 'min_phone_lenght',
   max_phone_lenght: 'max_phone_lenght',
   phone_mask: 'phone_mask',
   phone_code: 'phone_code',
   major_cities: 'major_cities'
};

export const CITIES = {
   SOURCE: 'cities',
   id: 'id',
   name: 'name',
   country_id: 'country_id',
};
export const ADMIN_USER_CREDENTIALS = {
   SOURCE: 'admin_user_credentials',
   id: 'id',
   user_id: 'user_id',
   can_change_bonus_points: 'can_change_bonus_points',
};
export const BONUS_INFO_TAG = {
   SOURCE: 'bonus_info_tag',
   id: 'id',
   tag_name: 'tag_name',
   country_id: 'country_id',
   value: 'value',
};

export const AREAS = {
   SOURCE: 'areas',
   id: 'id',
   name: 'name',
   city_id: 'city_id',
};
export const CURRENCIES = {
   SOURCE: 'currencies',
   id: 'id',
   name: 'name',
   symbol: 'symbol',
};
export const IP_LISTS = {
   SOURCE: 'iplists',
   id: 'id',
   ip: 'ip',
   list_type: 'list_type',
   description: 'description',
};

export const IP_LIST_TYPE: Object[] = [
   {id: 'whitelist', name: 'whitelist'},
   {id: 'blacklist', name: 'blacklist'}

];

export const IP_LIST_CONFIG = {
   SOURCE: 'ip-list-config',
   id: 'id',
   key: 'key',
   value: 'value',
};


export const ADMIN_LOGS = {
   SOURCE: 'admin_logs',
   id: 'id',
   user_id: 'user_id',
   user_email: 'user_email',
   link: 'link',
   activity_item_type: 'activity_item_type',
   activity_item_id: 'activity_item_id',
   activity_type: 'activity_type',
   created_at: 'created_at',
};

export const APP_VERSIONS = {
   SOURCE: 'app_versions',
   app_build: 'app_build',
   id: 'id'
};

export const REVIEWS: object[] = [
   {id: 'n_a', name: 'N/A'},
   {id: 'no_review', name: 'No Mirron review'},
   {id: 'reviewed', name: 'Reviewed by Mirron'},
]

export const USER_LIST_FIELDS = [
   {field: "id", type: '', element: '', sortable: true, label: 'ID', enabled: true, },
   {field: "username", type: '', element: '', sortable: true, label: 'User name', enabled: false, },
   {field: "email", type: '', element: 'email', sortable: true, label: 'Email', enabled: true, },
   {field: "fullname", type: '', element: '', sortable: true, label: 'Full Name', enabled: false, },
   {field: "phone_number", type: '', element: '', sortable: true, label: 'Phone', enabled: false, },
   {field: "whats_app", type: '', element: '', sortable: true, label: 'WhatsApp', enabled: false, },
   {field: "user_type", type: '', element: '', sortable: true, label: 'User Type', enabled: true, },
   {field: "status", type: '', element: '', sortable: true, label: 'Status', enabled: true, },
   {field: "provider", type: '', element: '', sortable: true, label: 'Provider', enabled: false, },
   {field: "created_at", type: '', element: 'date', sortable: true, label: 'Date of register', enabled: true, },
   {field: "updated_at", type: '', element: 'date', sortable: true, label: 'Last Update', enabled: false, },
   {field: "likes", type: '', element: '', sortable: true, label: 'Likes', enabled: false, },
   {field: "latest_activity_at", type: '', element: 'date', sortable: true, label: 'Last activity', enabled: false, },
   {field: "gender", type: '', element: '', sortable: true, label: 'Gender', enabled: false, },
   {field: "country_id", type: '', element: '', sortable: true, label: 'Country Id', enabled: false, },
   {field: "city_id", type: '', element: '', sortable: true, label: 'City Id', enabled: false, },
   {field: "area_id", type: '', element: '', sortable: true, label: 'Area Id', enabled: false, },
   {field: "user_info.app_build", type: '', element: '', sortable: false, label: 'App Version', enabled: false, },
   {field: "stylist_followers_count", type: '', element: '', sortable: true, label: 'Followers Number', enabled: false, },
   {field: "stylist_post_count", type: '', element: '', sortable: true, label: 'Posts Number', enabled: false, },
   {field: "bookings_made", type: '', element: '', sortable: true, label: 'Bookings Made', enabled: false, },
   {field: "stylist.booked_times", type: '', element: '', sortable: false, label: 'Booked Times', enabled: false, },
]

export const getUserListFields = () => {
   let parsedData = JSON.parse(localStorage.getItem('USER_LIST_FIELDS') || '[]');
   return parsedData.length ? parsedData : USER_LIST_FIELDS
}

export const SETTINGS = {
   SOURCE: 'settings',
   id: 'id',
   key: 'key',
   value: 'value',
};
